import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';
import { BASIC_METRICS } from '@/constants/metrics';

interface BasicMetricsSelectorProps {
  selected: string[];
  onChange: (metrics: string[]) => void;
}

export function BasicMetricsSelector({ selected, onChange }: BasicMetricsSelectorProps) {
  const handleToggle = (metric: string) => {
    if (selected.includes(metric)) {
      onChange(selected.filter((m) => m !== metric));
    } else {
      onChange([...selected, metric]);
    }
  };

  return (
    <div className="space-y-3">
      <Label>Métricas Básicas (Visíveis no Dashboard)</Label>
      <p className="text-sm text-muted-foreground">
        Selecione quais métricas básicas estarão disponíveis para este plano
      </p>
      <div className="grid grid-cols-2 gap-3">
        {BASIC_METRICS.map((metric) => (
          <div key={metric} className="flex items-center space-x-2">
            <Checkbox
              id={`basic-metric-${metric}`}
              checked={selected.includes(metric)}
              onCheckedChange={() => handleToggle(metric)}
            />
            <label
              htmlFor={`basic-metric-${metric}`}
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
            >
              {metric}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}
